/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Color_Definitions_Hex_ValueInputs */

const en_tables_color_definitions_hex_value = /** @type {(inputs: Tables_Color_Definitions_Hex_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value`)
};

const de_tables_color_definitions_hex_value = /** @type {(inputs: Tables_Color_Definitions_Hex_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value`)
};

/**
* | output |
* | --- |
* | "Value" |
*
* @param {Tables_Color_Definitions_Hex_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_color_definitions_hex_value = /** @type {((inputs?: Tables_Color_Definitions_Hex_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Color_Definitions_Hex_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_color_definitions_hex_value(inputs)
	return de_tables_color_definitions_hex_value(inputs)
});